import { render, staticRenderFns } from "./step-final.vue?vue&type=template&id=5421aa31&scoped=true"
import script from "./step-final.vue?vue&type=script&lang=js"
export * from "./step-final.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421aa31",
  null
  
)

export default component.exports